<template>
  <!-- 商品库 -->
  <div class="product main-container">
    <div class="content">
      <div class="search-box min">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">销售状态</span>
          <Select v-model="searchParams.salesStatus" clearable>
            <Option value="1">停售</Option>
            <Option value="2">在售</Option>
          </Select>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" @click="insureUrl('https://partner-h5.txb99.com/#/toolbox/jobTool')">团险职业查询</Button>
        </div>
      </div>
      <div class="tabs">
        <ul class="clearfix">
          <li @click="e => togglefilterTab(item)" v-for="(item, index) in filterTab" :key="index" :class="{ active: item.active === true }">
            {{ item.name }}
            <i v-if="item.active" class="line"></i>
          </li>
        </ul>
      </div>
      <div class="filterList" v-if="tableData.length > 0">
        <ul class="clearfix">
          <li v-for="(item, index) in filterList" @click="e => togglefilterList(item)" :class="{ active: item.active === true }">
            <span>{{ item.name }}</span>
            <span class="ivu-table-sort" v-if="index > 0" style="width: 21px">
              <i class="ivu-icon ivu-icon-md-arrow-dropup" :class="{ on: item.iconStatus === 2 }"></i>
              <i class="ivu-icon ivu-icon-md-arrow-dropdown" :class="{ on: item.iconStatus === 1 }"></i>
            </span>
          </li>
        </ul>
        <span class="proNum">
          共<span class="mainColor">{{ total }}</span
          >款产品
        </span>
      </div>
      <div class="list" v-if="tableData.length > 0">
        <div class="item clearfix" v-for="(item, index) in tableData" :key="index">
          <div class="title">
            <img v-if="item.dockChannel == 2" src="@static/images/smle-logo.png" />
            <span>{{ item.productName }}</span>
            <template v-if="item.sellType">
              <img v-if="item.sellType.includes('1')" class="icon-selltype" src="@static/images/product/icon_wx.png" />
              <img v-else-if="item.sellType.includes('3')" class="icon-selltype" src="@static/images/product/icon_jd.png" />
            </template>
            <template v-if="$units.isWTS()&&item.insureType">
              <img v-if="item.insureType.includes('2')" class="icon-selltype" src="@static/images/product/icon_daitou.png">
              <img v-if="item.insureType.includes('4')" class="icon-selltype" src="@static/images/product/icon_yuyue.png">
              <img v-if="item.insureType.includes('5')" class="icon-selltype" src="@static/images/product/icon_shouji.png">
              <img v-if="item.insureType.includes('6')" class="icon-selltype" src="@static/images/product/icon_dingtou.png">
              <img v-if="item.insureType.includes('7')" class="icon-selltype" src="@static/images/product/icon_wailian.png">
            </template>
            <img v-if="item.publishStatus == 1" class="icon-selltype" src="@static/images/product/icon_status.png" />
            <!-- 预售 -->
            <img v-if="item.preSale == 1" class="icon-selltype" src="@static/images/product/icon_ys.png" />
            <!-- 不可售 -->
            <img v-else-if="item.salesStatus == 1" class="icon-selltype" src="@static/images/product/icon_unsale.png" />
          </div>

          <div class="container-item">
            <div class="first">
              <div class="offline-time-box" v-if="item.offlineTime">
                <img class="icon-laba" src="@static/images/product/icon-laba.png" alt="" />
                产品将于{{ item.offlineTime | filterTime('YYYY年MM月DD日 HH:mm') }}下架
              </div>
              <div class="descList clearfix" v-if="item.goodness">
                <div class="descItem" v-for="its in item.goodness.replace(/<br>/g, '\n').split(/[\n]/)">
                  <Icon type="ios-checkmark-circle-outline" color="#236dff" size="18" />
                  <span>{{ its }}</span>
                </div>
              </div>
              <div class="other clearfix" v-if="item.feature">
                <div class="otherItem" v-for="its in item.feature.replace(/<br>/g, '\n').split(/[\n]/)">
                  {{ its }}
                </div>
              </div>
              <div class="divide"></div>
            </div>
            <div class="center">
              <div class="fr">
                <div class="tip">保费</div>
                <div class="txt">{{ item.insureCost ? item.insureCost : 0.0 }}元起</div>
              </div>
              <div class="fr" v-if="$units.pointAction('pro_8_1')">
                <div class="tip">服务费</div>
                <div
                  class="serverCon"
                  @click="
                    $router.push({
                      name: 'groupProductLookServer',
                      query: {
                        code: item.productCode,
                        type: item.productType,
                        status: item.publishStatus,
                        name: item.productName,
                        iconUrl: item.companyIcon,
                        productCategory: item.productCategory,
                        id: item.id,
                        infoText: item.settlementDescription,
                        urlType:'groupProduct',
                        timeStr:new Date().getTime()
                      }
                    })
                  "
                >
                  <div>
                    <span v-if="item.min != item.max">{{ item.min }}%~{{ item.max }}%</span>
                    <span v-else>{{ item.min }}%</span>
                    <Icon type="ios-arrow-forward" color="#ff7134 " size="16" />
                  </div>
                </div>
                <div v-if="item.activityInfoVO" class="serverCon">
                  <span class="timeLimit" v-if="userType != 3">限时加费</span>
                  {{ userType == 3 ? '业务员' : '' }}
                  <span v-if="item.activityInfoVO.commissionNum > 1">最高达</span>
                  {{ item.activityInfoVO.commission }}%
                </div>
                <div v-if="item.activityInfoVO" class="serverCon">
                  {{ item.activityInfoVO.startTime }}<span v-if="item.activityInfoVO.startTime && item.activityInfoVO.endTime">至</span>
                  {{ item.activityInfoVO.endTime }}
                </div>
              </div>
              <div class="fr" v-if="$units.superviseShowVal() && $units.pointAction('pro_8_2')">
                <div class="tip">供应商</div>
                <div class="txt">
                  {{ item.source }}
                </div>
              </div>
              <div class="fr company-logo">
                <img :src="item.companyIcon" />
              </div>
              <div class="fr resource-wrap">
                <div
                  @click="
                    $router.push({
                      name: 'groupPromotional',
                      query: { productCode: item.productCode, id: item.id, curNum: '0' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_resource.png" alt="" /><span>文档资料</span>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'groupPromotional',
                      query: { productCode: item.productCode, id: item.id, curNum: '1' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_poster.png" alt="" /><span>产品海报</span>
                </div>
              </div>
            </div>
            <!-- 按钮区 -->
            <div class="last">
              <div class="btn link-btn" v-if="item.publishStatus != 0" @click="goLinkList(item, true)">在线录单</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="tableData.length == 0">
        <loading :isShow="listLoading" />
        <div>
          <img src="@static/images/noData.png" alt />
        </div>
        <div>
          <span>暂无产品</span>
        </div>
      </div>
      <div class="pageBox" v-if="tableData.length > 0">
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center"
          show-sizer :page-size-opts="[10, 20, 30, 50, 100]" @on-page-size-change="pageSizeChange" />
      </div>
    </div>
    <!-- 获取链接 -->
    <get-link-modal ref="getLinkModal"></get-link-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pageTool } from '@/api/mixins';
import getLinkModal from './components/getLinkModal';
export default {
  mixins: [pageTool],
  components: { getLinkModal },
  props: {},
  data() {
    return {
      filterTabID: '',
      filterTab: [], //分类
      //三级标签
      filterList: [
        {
          name: '综合排序',
          active: true,
          value: ''
        },
        {
          name: '销量',
          iconStatus: 0,
          value: 1
        },
        {
          name: '上架时间',
          iconStatus: 0,
          value: 2
        },
        {
          name: '保费',
          iconStatus: 0,
          value: 3
        }
      ],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [], //产品列表
      userType: '' //账号类别 1、运营 2、商户 3、下级机构
    };
  },
  watch: {},
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.userType = JSON.parse(localStorage.getItem('userInfo')).userType;
  },
  mounted() {
    this.initListParams('/buz/productBase/read/groupList');
    this.getProductTheme();
  },
  activated() {
    this.getList();
  },
  methods: {
    //切换三级导航
    togglefilterList(item) {
      this.filterList.forEach(its => {
        this.$set(its, 'active', false);
        if (its.value != item.value) {
          its.iconStatus = 0;
        }
      });

      if (item.value != '') {
        //切换图标状态
        if (item.iconStatus === 0) {
          item.iconStatus = 1;
        } else if (item.iconStatus === 1) {
          item.iconStatus = 2;
        } else if (item.iconStatus === 2) {
          item.iconStatus = 1;
        }
      }
      this.$set(item, 'active', true);
      this.pageNo = 1;
      this.getList();
    },
    // 2级分类
    togglefilterTab(item) {
      this.filterTab.forEach(its => {
        this.$set(its, 'active', false);
      });
      this.$set(item, 'active', true);
      this.filterTabID = item.id;
      this.pageNo = 1;
      this.getList();
    },
    // 获取产品分类
    getProductTheme() {
      this.$http({
        url: '/buz/productTheme/array/secondByCode',
        type: 'GET',
        data: { code: 'TX' }
      }).then(res => {
        this.filterTab = res.data;
        if (this.filterTab.length > 0) {
          this.filterTab.unshift({
            name: '全部',
            active: true
          });
        }
      });
    },
    goLinkList(item) {
      if (item.isSalePermission != 1 && item.sourceType == 3) {
        //团险权限
        this.$notice.error('暂无该产品销售权限，请联系您的销售支持');
        return;
      }
      this.$router.push({
        name: 'groupInsuranceLink',
        query: {
          productCode: item.productCode,
          isGift: item.isGift,
          insureType: item.insureType,
          fromGroup: 1,
          backUrl:'/productResource/product/groupProduct'
        }
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'pro_1_0';
    },
    //设置查询参数
    setListParams(params) {
      params.secondTag = this.filterTabID;
      params.publishStatus = 2;// 已上架
      const bean = this.filterList.find(item => {
        return item.active;
      });
      if (bean) {
        params.orderCode = bean.value;
        if (bean.iconStatus === 1) {
          params.sortNo = 2;
        } else if (bean.iconStatus === 2) {
          params.sortNo = 1;
        } else {
          params.sortNo = '';
        }
      }
      return params;
    },
    listCallback(resData) {
      sessionStorage.removeItem('productName');
      sessionStorage.removeItem('productCode');
      resData.data.forEach(item => {
        if (item.titleLabel) {
          item.titleLabel = item.titleLabel.split(',');
        } else {
          item.titleLabel = [];
        }
      });
    },
    insureUrl(url) {
      if (!url) {
        this.$notice.error('该产品暂无投保流程');
        return;
      }
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
@import './groupProduct.scss';
</style>
